import { ShipmentHistory } from '@/components/modules/shipment/history';
import { LoadingSpinner } from '@/components/ui/loading/spinner';
import { UserMessage } from '@/components/ui/user-message';
import { useShipmentHistory } from '@/hooks/use-shipment-history';

export interface ShipmentHistoryListProps {
  shipmentId?: string;
}

const ShipmentHistoryList = ({ shipmentId }: ShipmentHistoryListProps) => {
  const { error, shipmentHistory, isLoading } = useShipmentHistory({
    shipmentId,
  });

  if (isLoading) {
    return (
      <div className="relative">
        <LoadingSpinner isVisible top="100px" />
      </div>
    );
  }

  if (error) {
    return <UserMessage variant="error" heading="Error" body="There was an error fetching shipment history" />;
  }

  return (
    <ul className="flex flex-col gap-4">
      {shipmentHistory?.length ? (
        shipmentHistory.map((historyEvent, i) => (
          <li key={i}>
            <ShipmentHistory historyEvent={historyEvent} />
          </li>
        ))
      ) : (
        <li className="text-baseSm">No history yet. As we track the shipment, changes will appear here.</li>
      )}
    </ul>
  );
};

export { ShipmentHistoryList };
